import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Color");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Color/GetById", {
      params: {
        'key': id
      }
    });
}
const GetByPlanCodeForUser = (planCode) => {
  return apiClient
    .get("/Color/GetByPlanCodeForUser", {
      params: {
        'PlanCodeKey': planCode
      }
    });
}

const ColorDropDown = () => {
  return apiClient
    .get("/Color/ColorDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/Color/GetForUser");
}

//type all:0, use:1, unUse:2
const Filter = (planCodeFilterParam) => {
  return apiClient
    .get("/Color/Filter", {
      params: {
        "planCodeFilterParam": planCodeFilterParam
      }
    });
}
const SoftDelete = (id) => {
  return apiClient
    .delete("/Color/SoftDelete", {
      params: {
        'Id': id
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Color', {
    'colorName': data.colorName,
    'colorCode': data.colorCode,
    'planCodeKey': data.planCodeKey
  }
  )
}

const Update = (data) => {
  return apiClient.put('/Color', {
    'colorName': data.colorName,
    'colorCode': data.colorCode,
    'planCodeKey': data.planCodeKey,
    'isActive': data.isActive
  }, {
    params: {
      'id': data.id
    }
  }
  )
}

const colorApi = { Add, Update, GetAll, GetByKey, ColorDropDown, GetForUser, Filter, GetByPlanCodeForUser }
export default colorApi;